class NativeBridge {
  constructor() {
    this.handlers = new Map()
  }

  on(type, handler) {
    if (!this.handlers.has(type)) {
      this.handlers.set(type, new Set())
    }

    this.handlers.get(type).add(handler)

    return () => this.off(type, handler)
  }

  off(type, handler) {
    if (!this.handlers.has(type)) {
      return
    }
    this.handlers.get(type).delete(handler)
  }

  once(type, handler) {
    const off = this.on(type, (payload) => {
      handler(payload)
      off()
    })
  }

  emit(type, payload) {
    if (!this.handlers.has(type)) {
      return
    }
    this.handlers.get(type).forEach((h) => h(payload))
  }
}

export const nativeBridge = new NativeBridge()
